import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { setExactAccountIdInCache } from "modules/DealerDetails/components/Invoicing/hooks";
import { ApiInstance } from "utils/Api";

import type { DealerID, DealerLocationID } from "models";

export type SaveExactAccountPayload = {
  exact_invoicing_company_name: string;
  exact_invoicing_email: string;
  exact_vat_number: string;
  exact_invoicing_address: string;
  exact_invoicing_zip_code: string;
  exact_invoicing_city: string;
  exact_invoicing_country: string;
  exact_invoicing_initials: string;
  exact_invoicing_last_name: string;
  exact_chamber_of_commerce: string;
  exact_invoicing_language?: string;
  dealer_id?: DealerID;
  dealer_location_id?: DealerLocationID;
};

export const useSaveExactAccountMutation = () =>
  useTypedMutation<SaveExactAccountPayload, string>({
    mutationFn: async payload => (await ApiInstance.post("/accounts/save", payload, ENV.exactBaseURL)).data.exact_account_id,
    onSuccess: ({ dealer_id, dealer_location_id }, exactAccountId) => setExactAccountIdInCache({ account_id: exactAccountId, dealer_id, dealer_location_id })
  });
